<script setup>
import backgroundPattern from '@components/assets/pages/BackgroundPattern.svg';
import proceduresScreenImage from '@components/assets/mok_screen.svg';
import announcementIcon from '@components/assets/pages/announcement-02.svg';
import responsibilityIcon from '@components/assets/icons/Responsibility.svg';
import youtubeIcon from '@components/assets/youtube.svg';

const starsIcon = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z" stroke="#7F56D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const folderLockIcon = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.5 15.1C8.5 14.5399 8.5 14.2599 8.60899 14.046C8.70487 13.8578 8.85785 13.7049 9.04601 13.609C9.25992 13.5 9.53995 13.5 10.1 13.5H13.9C14.4601 13.5 14.7401 13.5 14.954 13.609C15.1422 13.7049 15.2951 13.8578 15.391 14.046C15.5 14.2599 15.5 14.5399 15.5 15.1V15.9C15.5 16.4601 15.5 16.7401 15.391 16.954C15.2951 17.1422 15.1422 17.2951 14.954 17.391C14.7401 17.5 14.4601 17.5 13.9 17.5H10.1C9.53995 17.5 9.25992 17.5 9.04601 17.391C8.85785 17.2951 8.70487 17.1422 8.60899 16.954C8.5 16.7401 8.5 16.4601 8.5 15.9V15.1Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.25 11.75C10.25 10.7835 11.0335 10 12 10C12.9665 10 13.75 10.7835 13.75 11.75V13.5H10.25V11.75Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const file02Icon = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M4 6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 11H8M10 15H8M16 7H8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

const features = [
  {
    title: 'Document',
    description:
      'Document SOPs with pictures and Videos. Collaborate with others to compose and edit SPS in Realtime. Collect comments and feedback',
    iconMarkup: file02Icon,
  },
  {
    title: 'Control',
    description:
      'Strictly control publishing with version control. Revert to or consult old versions.',
    iconMarkup: folderLockIcon,
  },
  {
    title: 'Communicate',
    description:
      'Automatically notify people affected by a change of SOPs based on roles and responsibilities covering the SOP.',
    iconSrc: announcementIcon,
  },
  {
    title: 'Let AI correct your SOPs',
    description:
      'Use AI to review, refine, and correct SOPs for structure, clarity, consistency, and completeness.',
    iconMarkup: starsIcon,
  },
  {
    title: 'Generate SOPs from Videos',
    description:
      'Let AI analyze videos to extract Standard Operating Procedures.',
    iconSrc: youtubeIcon,
  },
  {
    title: 'Discover Roles and Responsibilities',
    description:
      'Automatically identify the roles and responsibilities required to execute each SOP.',
    iconSrc: responsibilityIcon,
  },
];
</script>

<template>
  <section
    class="procedures-coming-soon"
    :style="{ '--procedures-grid-pattern': `url(${backgroundPattern})` }"
  >
    <div class="procedures-coming-soon__content">
      <header class="procedures-coming-soon__hero">
        <div class="procedures-coming-soon__hero-badge">
          <span class="hero-badge__top">Coming Soon</span>
          <span class="hero-badge__bottom">Procedures</span>
        </div>

        <div class="procedures-coming-soon__main-heading">
          <h1 class="procedures-coming-soon__title">
            Manage Standard Operating Procedures
          </h1>
          <div class="procedures-coming-soon__subtitle-wrap">
            <p class="procedures-coming-soon__subtitle">
              Import existing procedures, generate SOPs with AI or from videos,
              and identify the roles and responsibilities required for execution.
              Generate Quizzes to test SOP knowledge.
            </p>
          </div>
        </div>
      </header>

      <div class="procedures-coming-soon__mockup-section">
        <div class="procedures-coming-soon__screenshot-container">
          <div class="procedures-coming-soon__screenshot-frame">
            <img
              :src="proceduresScreenImage"
              alt="Procedures Books preview"
              class="procedures-coming-soon__screenshot-image"
            />
          </div>
        </div>
      </div>

      <section class="procedures-coming-soon__secondary-content">
        <div class="procedures-coming-soon__secondary-inner">
          <h2 class="content-title">
            Clarity with Standard Operating Procedures
          </h2>
          <p class="content-subtitle">
            Clear, documented procedures give teams confidence in what to do, how
            to do it, and who owns it.
          </p>
        </div>

        <div class="procedures-coming-soon__features">
          <article
            v-for="feature in features"
            :key="feature.title"
            class="feature-card"
          >
            <div class="feature-icon-box" aria-hidden="true">
              <img
                v-if="feature.iconSrc"
                :src="feature.iconSrc"
                alt=""
                class="feature-icon-image"
              />
              <span
                v-else
                class="feature-icon-svg"
                v-html="feature.iconMarkup"
              />
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </article>
        </div>
      </section>
    </div>
  </section>
</template>

<style scoped>
.procedures-coming-soon {
  position: relative;
  overflow: hidden;
  padding: 80px 24px 120px;
  background:
    radial-gradient(circle at top center, rgba(127, 86, 217, 0.08), transparent 22%),
    linear-gradient(180deg, #fcfcfd 0%, #ffffff 34%, #ffffff 100%);
  color: #101828;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.procedures-coming-soon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 1920px;
  height: 1440px;
  background-image: var(--procedures-grid-pattern);
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 1920px 1440px;
  transform: translateX(-50%);
  opacity: 0.76;
  mask-image: linear-gradient(
      to right,
      transparent 0%,
      rgba(0, 0, 0, 1) 10%,
      rgba(0, 0, 0, 1) 90%,
      transparent 100%
    ),
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 0) 100%
    );
  -webkit-mask-image: linear-gradient(
      to right,
      transparent 0%,
      rgba(0, 0, 0, 1) 10%,
      rgba(0, 0, 0, 1) 90%,
      transparent 100%
    ),
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 0) 100%
    );
  -webkit-mask-composite: source-in;
  mask-composite: intersect;
  pointer-events: none;
}

.procedures-coming-soon__content {
  --procedures-hero-badge-max: 1050px;
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1374px;
  margin: 0 auto;
}

.procedures-coming-soon__hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.procedures-coming-soon__hero-badge {
  width: min(var(--procedures-hero-badge-max), 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Figma: paragraph spacing between “Coming Soon” and “Procedures” */
  gap: 21px;
  padding: 25px 32px;
  border-radius: 12px;
  background: #53389e;
  box-sizing: border-box;
}

.hero-badge__top,
.hero-badge__bottom {
  display: block;
  width: min(768px, 100%);
  color: #ffffff;
  text-align: center;
}

/* Figma: Display lg / Semibold — “Coming Soon” */
.hero-badge__top {
  margin: 0;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 48px;
  font-weight: 600;
  line-height: 60px;
  letter-spacing: -0.02em;
}

/* Figma: Inter Semibold — “Procedures” (36px / 60px line, -2%; hug height; fill max 768px). Paragraph gap 48px = badge gap. */
.hero-badge__bottom {
  margin: 0;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 36px;
  font-weight: 600;
  line-height: 60px;
  letter-spacing: -0.02em;
}

.procedures-coming-soon__main-heading {
  width: 100%;
  max-width: 1024px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Figma: paragraph spacing below “Manage Standard Operating Procedures” */
  gap: 60px;
  margin-top: 32px;
}

/* Figma: Display xl / Semibold — “Manage Standard Operating Procedures” (fill max 1024px, hug height) */
.procedures-coming-soon__title {
  width: min(1024px, 100%);
  margin: 0;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 60px;
  font-weight: 600;
  line-height: 72px;
  letter-spacing: -0.02em;
  text-align: center;
  color: #101828;
}

/* Figma: Text xl / Regular — fill max 768px, hug; paragraph spacing 20px */
.procedures-coming-soon__subtitle-wrap {
  max-width: 768px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
}

.procedures-coming-soon__subtitle {
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0;
  color: #667085;
  text-align: center;
}

/* Mock: same horizontal basis as hero; width = badge max − 20px */
.procedures-coming-soon__mockup-section {
  position: relative;
  z-index: 2;
  width: 100%;
  /* Shorter mock (cropped SVG) → slightly less overlap with features block */
  margin: 64px auto -155px;
  padding: 0;
  box-sizing: border-box;
}

.procedures-coming-soon__screenshot-container {
  width: 100%;
  /* Badge-aligned width + 200px; capped by content column */
  max-width: min(
    calc(var(--procedures-hero-badge-max) + 800px),
    100%
  );
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.procedures-coming-soon__screenshot-frame {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  /* Matches mok_screen.svg cropped viewport (1161×420), not full 678px artwork */
  background: transparent;
  aspect-ratio: 1161 / 420;
}

.procedures-coming-soon__screenshot-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  display: block;
}

.procedures-coming-soon__secondary-content {
  position: relative;
  z-index: 1;
  padding: 230px 32px 0;
  background: #ffffff;
}

.procedures-coming-soon__secondary-inner {
  max-width: 768px;
  margin: 0 auto;
  text-align: center;
}

.content-title {
  margin: 0;
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: -0.02em;
  color: #111827;
}

.content-subtitle {
  margin: 16px auto 0;
  max-width: 640px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #4b5563;
}

.procedures-coming-soon__features {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 48px 32px;
  max-width: 1200px;
  margin: 64px auto 0;
}

.feature-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  text-align: center;
}

.feature-icon-box {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
}

.feature-icon-image,
.feature-icon-svg :deep(svg) {
  width: 24px;
  height: 24px;
}

.feature-title {
  margin: 16px 0 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #111827;
}

.feature-description {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #4b5563;
}

@media (max-width: 1199px) {
  .procedures-coming-soon {
    padding: 72px 20px 96px;
  }

  .procedures-coming-soon__hero-badge {
    min-height: auto;
  }

  .hero-badge__top {
    font-size: 42px;
    line-height: 54px;
  }

  .hero-badge__bottom {
    font-size: 32px;
    line-height: 48px;
  }

  .procedures-coming-soon__main-heading {
    gap: 48px;
  }

  .procedures-coming-soon__title {
    font-size: 48px;
    line-height: 58px;
  }

  .procedures-coming-soon__mockup-section {
    width: 100%;
    margin-bottom: -135px;
    padding: 0;
  }

  .procedures-coming-soon__secondary-content {
    padding: 215px 24px 0;
  }
}

@media (max-width: 767px) {
  .procedures-coming-soon {
    padding: 56px 16px 72px;
  }

  .procedures-coming-soon__hero-badge {
    gap: 21px;
    padding: 20px 16px;
  }

  .hero-badge__top {
    font-size: 32px;
    line-height: 42px;
  }

  .hero-badge__bottom {
    font-size: 26px;
    line-height: 38px;
  }

  .procedures-coming-soon__main-heading {
    margin-top: 24px;
    gap: 24px;
  }

  .procedures-coming-soon__title {
    font-size: 36px;
    line-height: 44px;
  }

  .procedures-coming-soon__subtitle-wrap {
    gap: 16px;
  }

  .procedures-coming-soon__subtitle {
    font-size: 16px;
    line-height: 24px;
  }

  .procedures-coming-soon__mockup-section {
    width: 100%;
    margin: 40px auto -120px;
    padding: 0 16px;
  }

  .procedures-coming-soon__secondary-content {
    padding: 125px 0 0;
  }

  .content-title {
    font-size: 30px;
    line-height: 38px;
  }

  .procedures-coming-soon__features {
    grid-template-columns: 1fr;
    gap: 32px;
    margin-top: 40px;
  }

  .feature-card {
    padding: 0;
  }
}
</style>
